import { createContext } from 'react';

export interface MobileButtonFloatFlagContextType {
  noFloatingButton: boolean;
  setNoFloatingButton: (mobileButtonFloatFlag: boolean) => void;
}

/**
 * Mobile button float context to keep track of whether to have main CTA button floating or not.
 */
export const MobileButtonFloatFlagContext = createContext<MobileButtonFloatFlagContextType>({
  noFloatingButton: false,
  setNoFloatingButton: () => undefined,
});
